( function () {
	function initVivaCardSliders() {
		console.log('Initializing Viva Card Sliders');
		document
			.querySelectorAll( '.viva-block-cards__slider.swiper' )
			.forEach( function ( slider ) {
				if ( slider.swiper ) {
					return;
				}

				const columns = Math.max(
					1,
					parseInt( slider.dataset.columns, 10 ) || 1
				);
				const slides =
					slider.querySelectorAll( '.swiper-slide' ).length;
				const tabletColumns = Math.min( 2, columns );
				const prev = slider.querySelector(
					'.viva-block-cards__button--prev'
				);
				const next = slider.querySelector(
					'.viva-block-cards__button--next'
				);

				new window.Swiper( slider, {
					loop: slides > columns,
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 24,
					navigation: {
						prevEl: prev,
						nextEl: next,
					},
					watchOverflow: true,
					breakpoints: {
						600: {
							slidesPerView: tabletColumns,
						},
						900: {
							slidesPerView: columns,
						},
					},
				} );
			} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initVivaCardSliders );
	} else {
		initVivaCardSliders();
	}
} )();
